export const state = {
  root: null,
  steps: [],
  blocks: [],
  trad: {},
  currentBranch: 'default',
  branchSelections: Object.create(null),
  elements: {},

  init({ root, steps, blocks, trad, elements }) {
    this.root = root;
    this.steps = steps || [];
    this.blocks = blocks || [];
    this.trad = trad || {};
    this.elements = elements || {};
    this.currentBranch = 'default';
    this.branchSelections = Object.create(null);
  },

  switchBranch(name) {
    this.currentBranch = (name || 'default').toLowerCase();
  },

  getSelections() {
    const branch = this.currentBranch || 'default';

    if (!this.branchSelections[branch]) {
      this.branchSelections[branch] = Object.create(null);
    }

    return this.branchSelections[branch];
  }
};
